import { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import { useSelector } from "react-redux";
import HttpAPICall from "../../services/HttpAPICall";
import TapIcon from "../../services/TapIcon";
import ApplicationLayout from "../../layouts/ApplicationLayout";
import { DisplayListPagination } from "../../components/TapUi";
import Loader from "../../components/ui/Loader/Loader";
import { BACKOFFICE_BASE_URL } from "../../services/TapApiUrls";
import ChangeAssetCounterLogMeter from "../asset/ChangeAssetCounterLogMeter/ChangeAssetCounterLogMeter";
import GroupCard from "./GroupCard";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import GroupDetail from "./GroupDetail";
import UpdateLicenseModal from "./UpdateLicenseModal";

const NewGroupList = ({ history }) => {
    const licenseModalRef = useRef(null);
    const groupDetailRef = useRef(null);

    const access_token = useSelector((state) => state.auth.access_token);
    const permissions = useSelector((state) => state.app.acl_info?.permissions || []);

    const [listingLoading, setListingLoading] = useState(false);
    const [groupListing, setGroupListing] = useState([]);
    const [listingMeta, setListingMeta] = useState(null);
    const [minimizeTable, setMinimizable] = useState(false);
    const [showAssetMeter, setShowAssetMeter] = useState(false);
    const [detail_loading, setDetail_loading] = useState(false);
    const [groupDetail, setGroupDetail] = useState(null);
    const [selectedGroup, setSelectedGroup] = useState(null);

    useEffect(() => {
        loadListingTblData(1);
    }, []);

    const loadListingTblData = (page = 1) => {
        setListingLoading(true);
        const params = { page, per_page: 100 };
        HttpAPICall.withAthorization(
            "GET",
            BACKOFFICE_BASE_URL + "/group/list",
            access_token,
            params,
            {},
            (resp) => {
                const respData = resp.data;
                setGroupListing(respData.data);
                setListingMeta({
                    from: respData.from,
                    to: respData.to,
                    total: respData.total,
                    last_page: respData.last_page,
                    per_page: respData.per_page,
                    current_page: respData.current_page,
                });
            }
        ).then(() => setListingLoading(false));
    };

    const viewGroupDetail = (item) => {
        setMinimizable(true);
        setShowAssetMeter(false);
        setSelectedGroup(item);
    };

    const closeViewDetails = () => {
        setMinimizable(false);
        setShowAssetMeter(false);
    };

    const handleAssetMeter = () => {
        setMinimizable(false);
        setShowAssetMeter(true);
    };

    const updateLicenseModal = () => {
        if (licenseModalRef.current) {
            licenseModalRef.current.initModalHandler();
        }
    };

    const handleAssetMatrix = () => {
        history.push({
            pathname: `/change_asset_matrix`,
            state: { selectedGroup: selectedGroup },
        });
    };

    const handleTicketStatus = () => {
        history.push({
            pathname: `/change_ticket_status`,
            state: { selectedGroup: selectedGroup },
        });
    };

    const openCountUpdate = () => {
        groupDetailRef.current?.openCountUpdate();
    };

    const openModuleUpdate = () => {
        groupDetailRef.current?.openModuleUpdate();
    };

    const groupJsx = () => {
        return (
            <>
                <div className="page_title row m0">
                    {!showAssetMeter && (
                        <div className={minimizeTable ? "col-3" : "col-12"}>
                            <h3>Group List</h3>
                            <div className="text-end mt15">
                                {!minimizeTable ? <></> : null}
                            </div>
                        </div>
                    )}
                    <div className={[minimizeTable ? "col-9 tap_border_left" : "col-12"].join(" ")}>
                        <h3>
                            {minimizeTable
                                ? `Group: ${selectedGroup?.group_name || ""}`
                                : `Group: ${selectedGroup?.group_name || ""}`}
                        </h3>
                        <div className="text-end mt15 ">
                            {minimizeTable && (
                                <>
                                    <span className="dropdown">
                                        <button
                                            type="button"
                                            id="actionMenuButton"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                            className="btn btn-secondary"
                                        >
                                            Action
                                        </button>
                                        <ul className="dropdown-menu me-5 " aria-labelledby="dropdownMenuButton1">
                                            <>
                                                {permissions.includes("change_group_asset_counterlog_meter") && (
                                                    <li>
                                                        <button onClick={handleAssetMeter} className="dropdown-item">
                                                            Counterlog Configuration
                                                        </button>
                                                    </li>
                                                )}
                                                {permissions.includes("change_group_asset_counterlog_meter") && (
                                                    <li>
                                                        <button onClick={handleAssetMatrix} className="dropdown-item">
                                                            Change Asset Matrix
                                                        </button>
                                                    </li>
                                                )}
                                                {permissions.includes("change_group_asset_counterlog_meter") && (
                                                    <li>
                                                        <button onClick={handleTicketStatus} className="dropdown-item">
                                                            Change Ticket Status
                                                        </button>
                                                    </li>
                                                )}

                                                {/* ✅ New actions */}
                                                <li>
                                                    <button onClick={openModuleUpdate} className="dropdown-item">
                                                        Update Module/Sub-Module
                                                    </button>
                                                </li>
                                                <li>
                                                    <button onClick={openCountUpdate} className="dropdown-item">
                                                        Update Count
                                                    </button>
                                                </li>
                                            </>
                                        </ul>
                                    </span>
                                    {/* <button
                                        type="button"
                                        className="btn btn-secondary"
                                        data-bs-toggle="dropdown"
                                        role="button"
                                        aria-expanded="false"
                                    >
                                        <TapIcon.FontAwesomeIcon
                                            icon={TapIcon.faHistory}
                                            className="img-fluid mr3"
                                            alt="item-action"
                                        />
                                        History
                                    </button>
                                    <ul className="dropdown-menu dropdown-menu-end" style={{ cursor: "pointer" }}>
                                        <li>
                                            <Link className="dropdown-item">Asset Matrix</Link>
                                        </li>
                                    </ul> */}
                                </>
                            )}
                            <button type="button" className="btn btn-secondary" onClick={closeViewDetails}>
                                <TapIcon.imageIcon
                                    icon={TapIcon.CloseIcon}
                                    className="img-fluid"
                                    alt="item-close"
                                />
                            </button>
                        </div>
                    </div>
                </div>

                <div className="container-fluid pl5">
                    {showAssetMeter && (
                        <div className="page_containt row">
                            <div className="bg-white col-9 pl4" style={{ height: "100%" }}>
                                {assetMeterJsx()}
                            </div>
                            <div className="col-3 pl4 pe-2 page_containt" style={{ top: "0px" }}>
                                <GroupCard groupListing={selectedGroup} />
                            </div>
                        </div>
                    )}
                    {!showAssetMeter && (
                        <div className="page_containt row">
                            <div className={["pageTbl", minimizeTable ? "col-3" : "col-12"].join(" ")}>
                                {groupListingJsx()}
                            </div>
                            {minimizeTable && (
                                <div className="col-9 pr4 pl4">
                                    <div className="bg-white p-2" style={{ height: "100%" }}>
                                        <GroupDetail
                                            ref={groupDetailRef}
                                            groupDetail={selectedGroup}
                                            detail_loading={detail_loading}
                                        />
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </>
        );
    };
    const getLicenseColor = (dateString) => {
        if (!dateString) return "";
        const till = new Date(dateString);
        if (isNaN(till.getTime())) return "";

        const today = new Date();
        today.setHours(0, 0, 0, 0);
        till.setHours(0, 0, 0, 0);

        const diffDays = Math.ceil((till - today) / (1000 * 60 * 60 * 24));

        if (diffDays <= 0) return "#dc3545";   // 🔴 red — expired/today
        if (diffDays <= 30) return "#f59e0b";  // 🟡 yellow — ≤ 30 din
        return "#16a34a";                      // 🟢 green — > 30 din
    };

    /* ✅ Date + colored dot */
    const renderTillDate = (item, moduleKey) => {
        const mod = findModule(item, moduleKey);
        if (!mod || !mod.till) return "";

        const color = getLicenseColor(mod.till);

        return (
            <span style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}>
                <span
                    style={{
                        width: "12px",
                        height: "12px",
                        borderRadius: "50%",
                        backgroundColor: color,
                        display: "inline-block",
                        flexShrink: 0,
                    }}
                />
                <span>{formatDate(mod.till)}</span>
            </span>
        );
    };

    const formatDate = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return "";
        return `${date.getDate()}-${date.toLocaleString("default", { month: "short" })}-${date.getFullYear()}`;
    };

    const assetMeterJsx = () => (
        <section className="item_view_container bg-white pageTbl">
            <ChangeAssetCounterLogMeter master_id={selectedGroup.master_id} />
        </section>
    );
    const findModule = (item, moduleKey) => {
        if (!item?.module || !Array.isArray(item.module)) return null;
        return item.module.find((m) => m.module === moduleKey) || null;
    };

    const groupListingJsx = () => {

        return (
            <>
                <table className="table table-bordered table-fixed bg-white table-sm">
                    <thead className="table-secondary">
                        <tr className="text-center">
                            {minimizeTable || showAssetMeter ? (
                                <th scope="col">Name</th>
                            ) : (
                                <>
                                    <th scope="col" style={{ width: "4%" }}>S.No</th>
                                    <th scope="col" style={{ width: "9%" }}>Group ID</th>
                                    <th scope="col" style={{ width: "20%" }}>Name</th>
                                    <th scope="col" style={{ width: "14%" }}>IAM License</th>
                                    <th scope="col" style={{ width: "14%" }}>HRM License</th>
                                    <th scope="col" style={{ width: "14%" }}>ISC License</th>
                                    <th scope="col" style={{ width: "14%" }}>SCRM License</th>
                                    <th scope="col" className="text-center" style={{ width: "5%" }}>Action</th>
                                </>
                            )}
                        </tr>
                    </thead>
                    <tbody>
                        {listingLoading ? (
                            <tr><td colSpan="8"><Loader /></td></tr>
                        ) : groupListing && groupListing.length > 0 ? (
                            groupListing.map((item, index) => (
                                <tr key={index}>
                                    {minimizeTable || showAssetMeter ? (
                                        <td
                                            className="cursor_pointer link-primary"
                                            onClick={() => viewGroupDetail(item)}
                                        >
                                            {item.group_name || "-"}
                                        </td>
                                    ) : (
                                        <>
                                            <td className="text-center">
                                                {listingMeta ? listingMeta.from + index : index}
                                            </td>
                                            <td className="text-center">
                                                {item.master?.tap_master_id || "-"}
                                            </td>
                                            <td
                                                className="cursor_pointer link-primary"
                                                onClick={() => viewGroupDetail(item)}
                                            >
                                                {item.group_name || "-"}
                                            </td>
                                                <td className="text-center">{renderTillDate(item, "iam")}</td>
                                                <td className="text-center">{renderTillDate(item, "hrm")}</td>
                                                <td className="text-center">{renderTillDate(item, "isc")}</td>
                                                <td className="text-center">{renderTillDate(item, "scrm")}</td>
                                                <td className="text-center">
                                                    <TapIcon.imageIcon
                                                        icon={TapIcon.ListActionIcon}
                                                        alt="action-icon"
                                                        className="img-fluid px-3"
                                                    data-bs-toggle="dropdown"
                                                    href="#"
                                                    role="button"
                                                    aria-expanded="false"
                                                />
                                                <ul className="dropdown-menu " aria-labelledby="dropdownMenuButton1">
                                                    <li>
                                                        <button
                                                            className="dropdown-item"
                                                            onClick={() => viewGroupDetail(item)}
                                                        >
                                                            View
                                                        </button>
                                                    </li>
                                                </ul>
                                            </td>
                                        </>
                                    )}
                                </tr>
                            ))
                        ) : (
                            <tr><td colSpan="8" className="text-center">No Records</td></tr>
                        )}
                    </tbody>
                </table>
                <DisplayListPagination
                    meta={listingMeta}
                    onPageChange={(e) => loadListingTblData(e.selected + 1)}
                />
            </>
        );
    };

    return (
        <ApplicationLayout>
            <Helmet><title>New Group Listing</title></Helmet>
            {groupJsx()}
            <UpdateLicenseModal ref={licenseModalRef} groupDetail={groupDetail} />
        </ApplicationLayout>
    );
};

export default NewGroupList;